import React from "react";
import { FaChevronLeft, FaChevronRight, FaAngleDoubleLeft, FaAngleDoubleRight } from "react-icons/fa";
import styles from "./Pagination.module.css";

const Pagination = ({
    currentPage = 1,
    totalItems = 0,
    rowsPerPage = 10,
    onPageChange,
    onRowsPerPageChange,
    rowsPerPageOptions = [10, 25, 50, 100]
}) => {
    const totalPages = Math.max(1, Math.ceil(totalItems / rowsPerPage));

    const startIndex = totalItems === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
    const endIndex = Math.min(currentPage * rowsPerPage, totalItems);

    const getPageNumbers = () => {
        const pages = [];
        const maxVisible = 5;

        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            let start = Math.max(1, currentPage - 2);
            let end = Math.min(totalPages, start + maxVisible - 1);

            if (end - start < maxVisible - 1) {
                start = Math.max(1, end - maxVisible + 1);
            }

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }
        }
        return pages;
    };

    const pages = getPageNumbers();

    return (
        <div className={styles.paginationContainer}>
            <div className={styles.paginationInfoWrap}>
                <span className={styles.labelInfo}>
                    Showing <strong>{startIndex}</strong> to <strong>{endIndex}</strong> of <strong>{totalItems}</strong> entries
                </span>

                {onRowsPerPageChange && (
                    <div className={styles.rowsPerPageWrap}>
                        <label htmlFor="rows-per-page-select">Rows per page:</label>
                        <select
                            id="rows-per-page-select"
                            className={styles.rowsSelect}
                            value={rowsPerPage}
                            onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
                        >
                            {rowsPerPageOptions.map((opt) => (
                                <option key={opt} value={opt}>
                                    {opt}
                                </option>
                            ))}
                        </select>
                    </div>
                )}
            </div>

            <div className={styles.paginationControls}>
                <button
                    type="button"
                    className={styles.pageBtn}
                    onClick={() => onPageChange(1)}
                    disabled={currentPage === 1}
                    title="First Page"
                    aria-label="First Page"
                >
                    <FaAngleDoubleLeft />
                </button>

                <button
                    type="button"
                    className={styles.pageBtn}
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    title="Previous Page"
                    aria-label="Previous Page"
                >
                    <FaChevronLeft />
                </button>

                {pages.map((p) => (
                    <button
                        key={p}
                        type="button"
                        className={`${styles.pageBtn} ${currentPage === p ? styles.pageBtnActive : ""}`}
                        onClick={() => onPageChange(p)}
                    >
                        {p}
                    </button>
                ))}

                <button
                    type="button"
                    className={styles.pageBtn}
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages || totalItems === 0}
                    title="Next Page"
                    aria-label="Next Page"
                >
                    <FaChevronRight />
                </button>

                <button
                    type="button"
                    className={styles.pageBtn}
                    onClick={() => onPageChange(totalPages)}
                    disabled={currentPage === totalPages || totalItems === 0}
                    title="Last Page"
                    aria-label="Last Page"
                >
                    <FaAngleDoubleRight />
                </button>
            </div>
        </div>
    );
};

export default Pagination;
